import dayJs from 'dayjs';
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import objectSupport from "dayjs/plugin/objectSupport";
import weekday from "dayjs/plugin/weekday";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import dayOfYear from "dayjs/plugin/dayOfYear";
import 'dayjs/locale/da';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';
import 'dayjs/locale/nl-be';
dayJs.extend(duration);
dayJs.extend(utc);
dayJs.extend(timezone);
dayJs.extend(isBetween);
dayJs.extend(isSameOrAfter);
dayJs.extend(isSameOrBefore);
dayJs.extend(localeData);
dayJs.extend(localizedFormat);
dayJs.extend(customParseFormat);
dayJs.extend(objectSupport);
dayJs.extend(weekday);
dayJs.extend(advancedFormat);
dayJs.extend(isoWeek);
dayJs.extend(dayOfYear);

export const dayjs = dayJs;

export function parseDateFormat(dateFormat) {
  let delimiter = '';
  let datePattern = [];

  // Determine the delimiter by checking the characters in the format
  if (dateFormat.includes('-')) {
    delimiter = '-';
  } else if (dateFormat.includes('.')) {
    delimiter = '.';
  } else if (dateFormat.includes('/')) {
    delimiter = '/';
  }

  // Set the date pattern based on the format structure
  if (dateFormat === 'DD.MM.YYYY' || dateFormat === 'DD-MM-YYYY' || dateFormat === 'DD/MM/YYYY') {
    datePattern = ['d', 'm', 'Y'];
  } else if (dateFormat === 'YYYY-MM-DD') {
    datePattern = ['Y', 'm', 'd'];
  } else if (dateFormat === 'MM/DD/YYYY') {
    datePattern = ['m', 'd', 'Y'];
  }

  return { delimiter, datePattern };
}

export function momentify(date) {
  if (!date) {
    return dayjs();
  }
  if (typeof date === 'object' && date.toISOString !== undefined) {
    return dayjs(date);
  }
  let dateObj = momentifyDateTime(date);
  if (!dateObj.isValid()) {
    dateObj = momentifyDate(date);
  }
  if (!dateObj.isValid()) {
    dateObj = dayjs(date);
  }
  return dateObj;
}

export function momentifyDateTime(date) {
  return dayjs(date, window.jsDateTimeFormats, true);
}

export function momentifyDate(date) {
  return dayjs(date, window.jsDateFormats, true);
}

export function formatDate(date) {
  return momentify(date).format(window.jsDateFormat);
}
window.formatDate = formatDate;

export function formatDateISO(date) {
  return momentify(date).format('YYYY-MM-DD');
}

export function formatDateTime(date) {
  return momentify(date).format(window.jsDateTimeFormat);
}
window.formatDateTime = formatDateTime;

export function formatDateTimeISO(date) {
  return momentify(date).format('YYYY-MM-DD HH:mm');
}

export function formatTime(date) {
  return momentify(date).format(window.jsTimeFormat);
}

export function transformDateFormat(format)
{
  const cleanStr = format.replace(/[-\/.]/g, ' ');
  return cleanStr.replace(/MM/g, 'MMM');
}

export function is12HourFormat(format = null) {
  // Check if 'a' or 'A' (AM/PM) is present in the format
  return /a|A/.test(format ?? window.jsTimeFormat);
}
window.is12HourFormat = is12HourFormat;

export function convertToUtc(timeString) {
  if (!timeString || typeof timeString !== 'string') {
    return '';
  }

  const dateString = dayjs().tz(window.appTimezone).format('YYYY-MM-DD');
  const localDateTimeString = `${dateString} ${timeString}`;
  const localTime = dayjs.tz(localDateTimeString, 'YYYY-MM-DD HH:mm:ss', window.appTimezone);
  const utcTime = localTime.utc();
  return utcTime.format('HH:mm');
}
